"use client"

import { useState } from "react"
import "./TeamCarousel.scss"

const stories = [
  {
    id: 1,
    name: "Sarah Lim",
    location: "Kuala Lumpur",
    story:
      "Started with just RM 20,000 and now earning RM 8,000 monthly profit. Cakoi's changed my family's life completely!",
    monthlyProfit: "RM 8,000",
    duration: "8 months",
    rating: 5,
    image: "https://via.placeholder.com/200x200/CB0101/FFFFFF?text=SL",
  },
  {
    id: 2,
    name: "Ahmad Rahman",
    location: "Penang",
    story:
      "As a retiree, I wanted something to keep me busy. Now I have a thriving business and meet wonderful people daily.",
    monthlyProfit: "RM 6,500",
    duration: "1 year",
    rating: 5,
    image: "https://via.placeholder.com/200x200/CB0101/FFFFFF?text=AR",
  },
  {
    id: 3,
    name: "Priya Devi",
    location: "Selangor",
    story: "Single mother of two, Cakoi's partnership gave me financial independence and flexible working hours.",
    monthlyProfit: "RM 7,200",
    duration: "10 months",
    rating: 5,
    image: "https://via.placeholder.com/200x200/CB0101/FFFFFF?text=PD",
  },
  {
    id: 4,
    name: "Chen Wei Ming",
    location: "Johor",
    story: "From corporate stress to owning my own business. Best decision I ever made - work-life balance is amazing!",
    monthlyProfit: "RM 9,100",
    duration: "1.5 years",
    rating: 5,
    image: "https://via.placeholder.com/200x200/CB0101/FFFFFF?text=CW",
  },
]

const TeamCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % stories.length)
  }

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + stories.length) % stories.length)
  }

  const goToSlide = (index) => {
    setCurrentIndex(index)
  }

  return (
    <div className="team-carousel">
      <div className="carousel-container">
        <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {stories.map((story) => (
            <div key={story.id} className="carousel-slide">
              <div className="card story-card">
                <div className="story-content">
                  <div className="story-profile">
                    <img src={story.image || "/placeholder.svg"} alt={story.name} className="profile-image" />
                    <h3 className="profile-name">{story.name}</h3>
                    <p className="profile-location">{story.location}</p>
                    <div className="rating">
                      {[...Array(story.rating)].map((_, i) => (
                        <span key={i} className="star">
                          ★
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="story-details">
                    <blockquote className="story-quote">"{story.story}"</blockquote>

                    <div className="story-stats">
                      <div className="stat profit">
                        <div className="stat-value">{story.monthlyProfit}</div>
                        <p className="stat-label">Monthly Profit</p>
                      </div>
                      <div className="stat duration">
                        <div className="stat-value">{story.duration}</div>
                        <p className="stat-label">Partnership Duration</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button className="carousel-btn prev" onClick={prevSlide}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>

      <button className="carousel-btn next" onClick={nextSlide}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>

      {/* Dots Indicator */}
      <div className="carousel-dots">
        {stories.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  )
}

export default TeamCarousel
